<template>
  <section>
    <div class="container">
    <h1>{{ $t('faq_title') }}</h1>

        <h2 class="question" @click="toggle('faq-1')" id="faq-1" :class="{active: focus == 'faq-1'}">
          {{ $t('faq_1_question') }}
        </h2>
        <div class="answer">

          <i18n tag="p" path="faq_1_answer_1">
            <template v-slot:metaanalysis>
              <b>{{ $t('faq_1_answer_metaanalysis')}}</b>
            </template>
            <template v-slot:uncertainties>
              <b>{{ $t('faq_1_answer_uncertainties')}}</b>
            </template>
          </i18n>

          <p>
            {{ $t('faq_1_answer_2') }}
            <ul>
                <li>{{ $t('faq_1_answer_2_list_item_1') }}</li>
                <li>{{ $t('faq_1_answer_2_list_item_2') }}</li>
                <li>{{ $t('faq_1_answer_2_list_item_3') }}</li>
            </ul>
          </p>

          <p>
            {{ $t('faq_1_answer_3') }}
          </p>

          <p>
            {{ $t('faq_1_answer_4') }}
          </p>

          <i18n tag="p" path="faq_1_answer_5">
            <template v-slot:baysian_state_space_model>
              <a href="https://mc-stan.org/events/stancon2019Cambridge/abstracts.html#30" target="_blank">{{ $t('other_baysianmodel') }}</a>
            </template>
            <template v-slot:Github>
              <a href="https://github.com/INWTlab/lsTerm-election-forecast/" target="_blank">{{ $t('other_github') }}</a>    
            </template>
            <template v-slot:here>
              <a href="https://github.com/INWTlab/lsTerm-election-forecast/blob/master/Notebook/notebook.pdf" target="_blank">{{ $t('other_here') }}</a>
            </template>
          </i18n>

        </div>

        <h2 class="question" @click="toggle('faq-2')" id="faq-2" :class="{active: focus == 'faq-2'}">
          {{ $t('faq_2_question') }}
        </h2>
        <div class="answer">
          <p>
            {{ $t('faq_2_answer_1') }}
          </p>
          <p>
            {{ $t('faq_2_answer_2')}}
          </p>
        </div>


        <h2 class="question" @click="toggle('faq-3')" id="faq-3" :class="{active: focus == 'faq-3'}"> 
          {{ $t('faq_3_question') }}
        </h2>
        <div class="answer">
          <p>
            {{ $t('faq_3_answer_1') }}
            <ul>
                <li> {{ $t('faq_3_answer_over4000polls') }} <a href="https://www.wahlrecht.de/umfragen/index.htm" target="_blank">www.wahlrecht.de</a></li>
                <li><a href="https://raw.githubusercontent.com/INWTlab/lsTerm-election-forecast/master/data/Elections.csv" target="_blank">{{ $t('faq_3_answer_electionresults') }}</a></li>
                <li><a href="https://raw.githubusercontent.com/INWTlab/lsTerm-election-forecast/master/data/Government_read.csv" target="_blank">{{ $t('faq_3_answer_govstatus') }}</a></li>
                <li><a href="https://raw.githubusercontent.com/INWTlab/lsTerm-election-forecast/master/data/Koalitionen_read.csv" target="_blank">{{ $t('faq_3_answer_expertinterviews') }}</a></li>
            </ul>
          </p>
      </div>

      <h2 class="question" @click="toggle('faq-4')" id="faq-4" :class="{active: focus == 'faq-4'}"> 
        {{ $t('faq_4_question') }}
      </h2>
      <div class="answer">
          
          <i18n tag="p" path="faq_4_answer_1">
            <template v-slot:additional_info>
              <b>{{ $t('other_additional_info')}}</b>
            </template>
          </i18n>
        
          <i18n tag="p" path="faq_4_answer_2">
            <template v-slot:coalition_ranking_created>
              <b>{{ $t('faq_4_answer_2_coalition_ranking_created') }}</b>
            </template>
            <template v-slot:here>
              <a href="https://github.com/INWTlab/lsTerm-election-forecast/blob/master/Notebook/notebook.pdf">{{ $t('other_here') }}</a>    
            </template>
          </i18n>

          <p>
            {{ $t('faq_4_answer_3') }}
          </p>

          <i18n tag="p" path="faq_4_answer_4">
            <template v-slot:here>
              <a href="https://github.com/INWTlab/lsTerm-election-forecast/blob/master/Notebook/notebook.pdf">{{ $t('other_here') }}</a>    
            </template>
          </i18n>
          
      </div>


      <h2 class="question" @click="toggle('faq-5')" id="faq-5" :class="{active: focus == 'faq-5'}"> 
        {{ $t('faq_5_question') }}
      </h2>
      <div class="answer">

        <i18n tag="p" path="faq_5_answer_1">
          <template v-slot:credible_intervals>
            <b>{{ $t('faq_5_answer_1_credible_intervals') }}</b>
          </template>
        </i18n>

        <i18n tag="p" path="faq_5_answer_2">
          <template v-slot:yes_no_questions>
            <b>{{ $t('faq_5_answer_2_yes_no_questions') }}</b>
          </template>
          <template v-slot:link_faq_8_question>
            <router-link :to="'/' + $i18n.locale + '/faq#faq-8'">{{ $t('faq_8_question') }}</router-link>
          </template>
        </i18n>

        <i18n tag="p" path="faq_5_answer_3">
          <template v-slot:fit_better_than_polls>
            <b>{{ $t('faq_5_answer_3_fit_better_than_polls') }}</b>
          </template>
        </i18n>

      </div>


      <h2 class="question" @click="toggle('faq-6')" id="faq-6" :class="{active: focus == 'faq-6'}"> 
        {{ $t('faq_6_question') }}
      </h2>
      <div class="answer">

        <i18n tag="p" path="faq_6_answer_1">
          <template v-slot:high_precision>
            <b>{{ $t('faq_6_answer_1_high_precision') }}</b>
          </template>
          <template v-slot:quantify_uncertainty>
            <b>{{ $t('faq_6_answer_1_quantify_uncertainty') }}</b>
          </template>
        </i18n>

        <i18n tag="p" path="faq_6_answer_2">
          <template v-slot:no_certain_model>
            <b>{{ $t('faq_6_answer_2_no_certain_model') }}</b>
          </template>
        </i18n>

        <p>
          {{ $t('faq_6_answer_3') }}
        </p>

      </div>

      
      <h2 class="question" @click="toggle('faq-7')" id="faq-7" :class="{active: focus == 'faq-7'}"> 
        {{ $t('faq_7_question') }}
      </h2>
      <div class="answer">

        <i18n tag="p" path="faq_7_answer_1">
          <template v-slot:link_FiveThirtyEight>
            <a href="https://projects.fivethirtyeight.com/2020-election-forecast/" target="_blank">{{ $t('other_fivethirtyeight') }}</a>               
          </template>
        </i18n>

        <i18n tag="p" path="faq_7_answer_2">
          <template v-slot:other_approach>
            <b>{{ $t('faq_7_answer_2_other_approach') }}</b>
          </template>
        </i18n>

        <i18n tag="p" path="faq_7_answer_3">
          <template v-slot:short_long_memory>
            <b>{{ $t('faq_7_answer_3_short_long_memory') }}</b>
          </template>
        </i18n>

      </div>

      <h2 class="question" @click="toggle('faq-8')" id="faq-8" :class="{active: focus == 'faq-8'}"> 
        {{ $t('faq_8_question') }}
      </h2>
      <div class="answer">
          <p>
            {{ $t('faq_8_answer_1') }}
          </p>

        <i18n tag="p" path="faq_8_answer_2">
          <template v-slot:example>
            <b>{{ $t('other_example') }}</b>
          </template>
        </i18n>

      </div>

      <h2 class="question" @click="toggle('faq-9')" id="faq-9" :class="{active: focus == 'faq-9'}"> 
        {{ $t('faq_9_question') }}
      </h2>
      <div class="answer">
          
          <p>
            <b>{{ $t('faq_9_answer_1') }}</b>
          </p>

          <p>
            {{ $t('faq_9_answer_2') }}
          </p>

      </div>

            <h2 class="question" @click="toggle('faq-12')" id="faq-12" :class="{active: focus == 'faq-12'}"> 
        {{ $t('faq_12_question') }}
      </h2>
      <div class="answer">
          
          <p>
            <b>{{ $t('faq_12_answer_1') }}</b>
          </p>

          <p>
            {{ $t('faq_12_answer_2') }} <a href="https://www.bundestag.de/services/glossar/glossar/A/ausgleichsmandat-259632" target="_blank">www.bundestag.de</a>
          </p>

      </div>


      <h2 class="question" @click="toggle('faq-10')" id="faq-10" :class="{active: focus == 'faq-10'}"> 
        {{ $t('faq_10_question') }}
      </h2>
      <div class="answer">

          <p>
            <b>{{ $t('other_we_are') }} <a href="https://www.inwt-statistics.de" target="_blank">INWT Statistics</a></b>, 
             {{ $t('faq_10_answer_1') }}
          </p>

        <i18n tag="p" path="faq_10_answer_2">
          <template v-slot:specialized_company>
            <b>{{ $t('faq_10_answer_2_specialized_company') }}</b>
          </template>
        </i18n>

      </div>


      <h2 class="question" @click="toggle('faq-11')" id="faq-11" :class="{active: focus == 'faq-11'}"> 
        {{ $t('faq_11_question') }}
      </h2>
      <div class="answer">

        <i18n tag="p" path="faq_11_answer_1">
          <template v-slot:independent>
            <b>{{ $t('faq_11_answer_1_independent') }}</b>
          </template>
          <template v-slot:link_fivethirtyeight>
            <a href="https://projects.fivethirtyeight.com/2020-election-forecast/" target="_blank">{{ $t('other_fivethirtyeight') }}</a>
          </template>
        </i18n>

        <i18n tag="p" path="faq_11_answer_2">
          <template v-slot:model_free_opensource>
            <b>{{ $t('faq_11_answer_2_model_free_opensource') }}</b>
          </template>
          <template v-slot:link_github>
            <a href="https://github.com/INWTlab/lsTerm-election-forecast/" target="_blank">{{ $t('other_github') }}</a> 
          </template>
        </i18n>

      </div>
    </div>
</section>
</template>

<script>
export default {
  data() {
    return {
      focus: null,
    };
  },
  methods: {
    toggle: function (id) {
      let answer = document.getElementById(id).nextSibling;
      let allAnswers = this.$el.getElementsByClassName("answer");
      for (let i = 0; i < allAnswers.length; i++) {
        allAnswers[i].classList.remove("expand");
      }

      if (this.focus != id) {
        answer.classList.add("expand");
        this.focus = id;

        this.scrollTo(id);
      } else {
        this.focus = null;
      }
    },
    scrollTo(id, direct) {
      // scroll to correct position
      let navbar = document.getElementsByClassName("navbar-container")[0];
      let question = document.getElementById(id);

      let topOfElement = question.offsetTop - navbar.offsetHeight - 10;
      window.scroll({
        top: topOfElement,
        behavior: direct ? "auto" : "smooth",
      });
    },
  },
  mounted() {
    if (this.$route.hash) {
      let id = this.$route.hash.substr(1);

      if (!document.getElementById(id)) return;

      let answer = document.getElementById(id).nextSibling;

      this.focus = id;

      answer.style.maxHeight = answer.classList.add("expand");

      this.scrollTo(id, true);
    }
  },
};
</script>

<style scoped>
h2 {
  top: 0;
  position: initial;
  display: inline;
}

h2::before {
  display: inline-block;
  font-style: normal;
  font-variant: normal;
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
  content: "\f107";
  transform: rotate(0deg);
  transition: transform 250ms ease;
}

h2.active::before {
  transform: rotate(-180deg);
}

.answer {
  max-height: 0;
  overflow: hidden;
  margin-bottom: 2em;
}

.answer.expand {
  max-height: initial;
}

.question {
  cursor: pointer;
  margin-top: 20px;
  margin-bottom: 20px;
}

.question svg {
  transform: rotate(0deg);
}

.question.active svg {
  transform: rotate(180deg);
  transition: transform 250ms;
}
</style>